import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { listGuests } from '../../api/calls';
import '../CheckInModal/modalOverwrite.css';

const AllGuestsModal = ({ show, onHide, members }) => {
    const [guests, setGuests] = useState([]);
    const [sortField, setSortField] = useState('date');
    const [sortDir, setSortDir] = useState('desc');

    useEffect(() => {
        if (show) {
            listGuests().then(all => {
                setGuests(all.filter(g => g.name));
            });
        }
    }, [show]);

    const handleSort = (field) => {
        if (field === sortField) {
            setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir(field === 'date' ? 'desc' : 'asc');
        }
    };

    const indicator = (field) => field === sortField ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '';

    const memberMap = members
        ? members.reduce((acc, m) => { acc[m.PK] = m; return acc; }, {})
        : {};

    const sorted = [...guests].sort((a, b) => {
        let aVal, bVal;
        if (sortField === 'sponsor') {
            const aM = memberMap[a.member];
            const bM = memberMap[b.member];
            aVal = aM ? `${aM.lastName} ${aM.firstName}` : '';
            bVal = bM ? `${bM.lastName} ${bM.firstName}` : '';
        } else {
            aVal = a[sortField] ?? '';
            bVal = b[sortField] ?? '';
        }
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
        }
        const aStr = String(aVal).toLowerCase();
        const bStr = String(bVal).toLowerCase();
        if (aStr < bStr) return sortDir === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortDir === 'asc' ? 1 : -1;
        return 0;
    });

    const thStyle = { cursor: 'pointer', userSelect: 'none' };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-90w" centered>
            <Modal.Header closeButton>
                <Modal.Title>Guest Log</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered size="sm">
                    <thead>
                        <tr>
                            <th style={thStyle} onClick={() => handleSort('date')}>Date{indicator('date')}</th>
                            <th style={thStyle} onClick={() => handleSort('name')}>Guest Name{indicator('name')}</th>
                            <th style={thStyle} onClick={() => handleSort('cellEmail')}>Cell/Email{indicator('cellEmail')}</th>
                            <th style={thStyle} onClick={() => handleSort('guestCount')}>Party Size{indicator('guestCount')}</th>
                            <th style={thStyle} onClick={() => handleSort('payment')}>Payment{indicator('payment')}</th>
                            <th style={thStyle} onClick={() => handleSort('sponsor')}>Sponsor{indicator('sponsor')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map(g => {
                            const sponsor = memberMap[g.member];
                            return (
                                <tr key={g.PK}>
                                    <td>{new Date(g.date).toLocaleString()}</td>
                                    <td>{g.name}</td>
                                    <td>{g.cellEmail || '—'}</td>
                                    <td>{g.guestCount}</td>
                                    <td>{g.payment}</td>
                                    <td>{sponsor ? `${sponsor.lastName}, ${sponsor.firstName}` : '—'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};

export default AllGuestsModal;
